<template>
  <div>
    <main class="main">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><a href="index.html">首頁</a></li>
            <li>交易問題</li>
          </ul>
        </div>
      </div>

      <!--內容開始-->

      <div class="bodyContent">
        <div class="container">
          <section class="uploadArea p_mgin20">
            <div class="innerHeader">
              <h1>交易問題</h1>
            </div>

            <h2>購買點數後，卻沒有取得點數</h2>
            <div class="group_pList">
              <p>
                請您依照下方步驟查看您的資訊，以便客服人員後續為您處理：
              </p>
              <ol>
                <li>
                  <p>請確認您已登入購買時所使用的帳戶，並在一刻鯨選 App 首頁的右上角，進入「我的」，再進到您的個人資料頁，提供您的<strong>「ID」及「登入方式」</strong>給我們。</p>
                  <p><img src="https://jinfm.net/images/content/App_account.jpg" width="100%"></p>
                </li>
                <li>
                  <p>請您在一刻鯨選 App 首頁的右上角，進入「我的」，並點選「交易紀錄」查看是否有您當下購買的紀錄。</p>
                  <p><img src="https://jinfm.net/images/content/App_order.jpg" width="100%"></p>
                  <p>>> 如果有的話，請您將<strong>該筆交易紀錄截圖</strong>寄給我們。若顯示「交易失敗」，您可以點擊下方「更新交易狀態」按鈕，重新確認交易狀況。</p>
                  <p>>> 如果沒有的話，請您到您的 Google 信箱，確認是否有收到 Google Play 寄來的信，主旨是「您的 Google Play 訂單收據」，信件中會提到您在 Google Play 向 聯合報股份有限公司 購買了商品。下方會有<strong>「訂單號碼」及「訂單日期」</strong>，請您提供給我們，或是截圖下來讓我們向 Google 進行確認。</p>
                  <p><img src="https://jinfm.net/images/content/App_GPA.jpg" width="50%"></p>
                </li>
              </ol>
            </div>

            <h2>兌換課程後，App 仍無法收聽音頻</h2>
            <div class="group_pList">
              <p>請您依照下方步驟查看您的資訊，以便客服人員後續為您處理：</p>
              <ol>
                <li>
                  <p>請確認您已登入購買時所使用的帳戶，並在一刻鯨選 App 首頁的右上角，進入「我的」，再進到您的個人資料頁，提供您的<strong>「ID」及「登入方式」</strong>給我們。</p>
                  <p><img src="https://jinfm.net/images/content/App_account.jpg" width="100%"></p>
                </li>
                <li>
                  <p>請您在一刻鯨選 App 首頁的右上角，進入「我的」，並點選「交易紀錄」查看是否有您當下兌換的紀錄。</p>
                  <p><img src="https://jinfm.net/images/content/App_order.jpg" width="100%"></p>
                  <p> 若顯示「兌換成功」，請您重新開啟 App 後再看看課程是否可收聽。</p>
                  <p> 若顯示「兌換失敗」，您可以點擊下方「更新交易狀態」按鈕，重新確認交易狀況；若仍然顯示「兌換失敗」，請點擊一刻鯨選 App 連絡我們，將<strong>交易紀錄的截圖</strong>提供給我們進行後續處理。</p>
                </li>
              </ol>
            </div>
          </section>
        </div>
      </div>

      <!--內容結束-->

    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'async',
  metaInfo () {
    return {

      title: '交易問題 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '交易問題 | 一刻鯨選' },
        { property: 'og:site_name', content: '交易問題 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

      ]
    }
  },

  data () {
    return {
      classData: []
    }
  },
  methods: {

    changePage (page) {
      this.$router.push({ path: '/' + page })
    }

  },
  mounted () {
    $('body').removeClass('index')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/point_payment.vue